firebird.factory('inputService', [
    function () {
        var focusedInputsCount = 0;
        var notesElement = null;

        var service = {
            isInputFocused: isInputFocused,
            incrementInputFocused: incrementInputFocused,
            decrementInputFocused: decrementInputFocused,
            getFocusedInputsCount: getFocusedInputsCount,
            setNotesElement: setNotesElement,
            getNotesElement: getNotesElement
        };

        return service;

        ////////////////////////

        function isInputFocused() {
            var notes = service.getNotesElement();
            if (notes && notes.hasFocus()) {
                return true;
            }

            return focusedInputsCount > 0;
        }

        function incrementInputFocused() {
            focusedInputsCount++;
        }

        function decrementInputFocused() {
            focusedInputsCount--;

            if (focusedInputsCount <= 0) {
                focusedInputsCount = 0;
            }
        }

        function getFocusedInputsCount() {
            return focusedInputsCount;
        }

        function setNotesElement(newNotesElement) {
            notesElement = newNotesElement;
        }

        function getNotesElement() {
            return notesElement;
        }
    }
]);
